<script lang="ts">
	import PageHero from "@components/PageHero.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { DemandProps } from "./DemandProps.js";

	const _: DemandProps = $props();
</script>

<Layout>
	<PageHero
		headline="Navázejte s námi spolupráci ještě dnes"
		description="Stačí vyplnit jednoduchý formulář a my se vám co nejdříve ozveme."
	/>
</Layout>
